import React, { useState, useEffect } from 'react';
import { Modal, Button, Dropdown, Form } from 'react-bootstrap';
import { createUserSalary } from '../../../../../../../../crud/management_api/user_salaries';
import { toast } from 'react-toastify';
import { X } from 'react-bootstrap-icons';
import {FaInfoCircle} from 'react-icons/fa';
import { getUsersByLocalId } from '../../../../../../../../crud/users_api/users';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SearchDropdown from '../../../../../../../../components/common/SearchDropdown/SearchDropdown';

interface CreateNewSalaryProps {
  show: boolean;
  handleClose: () => void;
  setData: React.Dispatch<React.SetStateAction<any[]>>;
  data: any[]; // Datos existentes
}

const CreateNewSalary: React.FC<CreateNewSalaryProps> = ({ show, handleClose, setData, data }) => {
  const [localId, setLocalId] = useState<number | null>(null);
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
  const [year, setYear] = useState<number>(new Date().getFullYear() % 100); // Últimos dos dígitos del año
  const [userId, setUserId] = useState<number | null>(null);
  const [totalPayed, setTotalPayed] = useState<number | null>(null);
  const [netPayed, setNetPayed] = useState<number | null>(null);
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);

  useEffect(() => {
    const fetchFilteredUsers = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user') ?? '{}');
        const localId = user?.local_id || null;
        setLocalId(localId);

        if (localId) {
          const response = await getUsersByLocalId(localId);
          const allUsers = response.data;

          // Filtrar usuarios que ya están en los datos existentes
          const existingUserIds = data.map((item) => item.user_id);
          const filtered = allUsers.filter(
            (user: any) => !existingUserIds.includes(user.user_id)
          );

          setFilteredUsers(filtered);
        } else {
          console.warn('Local ID no encontrado en localStorage');
        }
      } catch (error) {
        console.error('Error al obtener los usuarios:', error);
      }
    };

    fetchFilteredUsers();
  }, [data]);

  const handleCloseModal = () => {
    setTotalPayed(null);
    setNetPayed(null);
    setUserId(null);
    setMonth(new Date().getMonth() + 1);
    setYear(new Date().getFullYear() % 100);
    handleClose();
  };

// Reemplaza tu handleCreate por esta versión que añade directamente el objeto JSON de la respuesta:
const handleCreate = async () => {
  if (localId && userId && month && year && totalPayed != null) {
    const monthYear = `${month.toString().padStart(2, '0')}/${year
      .toString()
      .padStart(2, '0')}`

    const newSalary = {
      local_id: localId,
      user_payment_number: null,
      month_year: monthYear,
      user_id: userId,
      total_payed: totalPayed,
      net_payed: netPayed,
      salary_metadata: null,
    }

    try {
      // Llamada al API y destructuring para tomar el data:
      const { data: created } = await createUserSalary(newSalary)

      toast.success('Salario creado con éxito')

      // Añade el objeto entero devuelto por el API al array de datos:
      setData(prev => [...prev, created])

      handleCloseModal()
    } catch (error) {
      console.error('Error al crear el salario:', error)
      toast.error('Error al crear el salario')
    }
  } else {
    toast.error('Por favor completa todos los campos obligatorios.')
  }
}


  const monthNames = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i);

  return (
    <Modal show={show} onHide={handleCloseModal} centered>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Crear nuevo salario</Modal.Title>
        </div>
        <Button variant="none" onClick={handleCloseModal}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form>
<Form.Group className="mp-formgroup horizontal">
  <Form.Label>Usuario</Form.Label>
  <SearchDropdown
    items={filteredUsers.map(user => ({
      ...user,
      fullName: `${user.username} ${user.last_name}`
    }))}
    selected={filteredUsers
      .map(user => ({ ...user, fullName: `${user.username} ${user.last_name}` }))
      .find(user => user.user_id === userId) || null
    }
    setSelected={(user) => setUserId(user ? user.user_id : null)}
    placeholder="Seleccionar usuario"
    displayProperty="fullName"
    idProperty="user_id"
  />
</Form.Group>

          <Form.Group className="mp-formgroup horizontal">
            <Form.Label>Mes</Form.Label>
            <Dropdown className="mp-dropdown" onSelect={(eventKey) => setMonth(Number(eventKey))}>
              <Dropdown.Toggle variant="none" id="dropdown-month">
                {monthNames[month - 1]}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {monthNames.map((name, index) => (
                  <Dropdown.Item key={index + 1} eventKey={(index + 1).toString()}>
                    {name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>

          <Form.Group className="mp-formgroup horizontal">
            <Form.Label>Año</Form.Label>
            <Dropdown className="mp-dropdown" onSelect={(eventKey) => setYear(Number(eventKey))}>
              <Dropdown.Toggle variant="none" id="dropdown-year">
                {years.find((y) => y % 100 === year) || years[0]}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {years.map((y) => (
                  <Dropdown.Item key={y} eventKey={(y % 100).toString()}>
                    {y}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>

          <Form.Group className="mp-formgroup horizontal total-payed">
            <Form.Label style={{flexBasis:'20%'}}>Total desembolsado</Form.Label>
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-total-payed">
                  Este es el total que se desembolsa al empleado, incluyendo deducciones y aportes.
                </Tooltip>
              }
            >
              <span className="ms-2 info-create-item" style={{ cursor: 'pointer' }}>
                <FaInfoCircle color="#6c757d" />
              </span>
            </OverlayTrigger>
            <Form.Control
              type="number"
              placeholder="Ingrese el total pagado"
              value={totalPayed || ''}
              onChange={(e) => setTotalPayed(Number(e.target.value))}
            />
          </Form.Group>

          <Form.Group className="mp-formgroup horizontal">
            <Form.Label>Recibido por el empleado</Form.Label>
            <Form.Control
              type="number"
              placeholder="Ingrese el pago neto"
              value={netPayed || ''}
              onChange={(e) => setNetPayed(Number(e.target.value))}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="none" className="form-button-cancel" onClick={handleCloseModal}>
          Cerrar
        </Button>
        <Button variant="none" className="form-button-create" onClick={handleCreate}>
          Crear
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateNewSalary;
